// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: 5TRnqrBQOr
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicHeroCityImg.module.css"; // plasmic-import: 5TRnqrBQOr/css
import screenshot16PngJqyXn7MrEJg5 from "./images/screenshot16Png.png"; // plasmic-import: JqyXn7mrEJg5/picture

createPlasmicElementProxy;

export const PlasmicHeroCityImg__VariantProps = new Array();

export const PlasmicHeroCityImg__ArgProps = new Array("cityImageProp");

const $$ = {};

function PlasmicHeroCityImg__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          cityImageProp: {
            src: screenshot16PngJqyXn7MrEJg5,
            fullWidth: 767,
            fullHeight: 594,
            aspectRatio: undefined
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <PlasmicImg__
        data-plasmic-name={"img"}
        data-plasmic-override={overrides.img}
        alt={""}
        className={classNames(sty.img)}
        displayHeight={"auto"}
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"auto"}
        loading={"lazy"}
        src={args.cityImageProp}
      />
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHeroCityImg__ArgProps,
          internalVariantPropNames: PlasmicHeroCityImg__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHeroCityImg__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHeroCityImg";
  } else {
    func.displayName = `PlasmicHeroCityImg.${nodeName}`;
  }
  return func;
}

export const PlasmicHeroCityImg = Object.assign(
  // Top-level PlasmicHeroCityImg renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicHeroCityImg
    internalVariantProps: PlasmicHeroCityImg__VariantProps,
    internalArgProps: PlasmicHeroCityImg__ArgProps
  }
);

export default PlasmicHeroCityImg;
/* prettier-ignore-end */
